import { ContentModuleFormState } from "@/content-usage/modules/actions/ContentModuleForm"
import { ContentModuleForm_UpdateContentUsageMutation } from "@/content-usage/modules/actions/__generated__/ContentModuleForm_UpdateContentUsageMutation.graphql"
import FormStore from "@/core/form/store/FormStore"
import {
  DiscoAlert,
  DiscoDivider,
  DiscoFormControl,
  DiscoSwitch,
  DiscoText,
} from "@disco-ui"
import { observer } from "mobx-react-lite"

interface ContentModuleTimeEstimateSettingProps {
  form: FormStore<ContentModuleFormState, ContentModuleForm_UpdateContentUsageMutation>
}

function ContentModuleTimeEstimateSetting({
  form,
}: ContentModuleTimeEstimateSettingProps) {
  return (
    <>
      <DiscoDivider />
      <DiscoFormControl marginBottom={1} marginTop={1}>
        <DiscoSwitch
          testid={"ContentModuleTimeEstimateSetting.toggle"}
          name={"toggle-time-estimate"}
          checked={form.state.isTimeEstimateEnabled}
          onChange={handleToggle}
          label={<DiscoText variant={"body-md-600"}>{"Time Estimate"}</DiscoText>}
          sublabel={
            <DiscoText variant={"body-sm"} color={"groovy.neutral.700"}>
              {`Set completion times for all content in this module.`}
            </DiscoText>
          }
        />
      </DiscoFormControl>
      {form.initialState.isTimeEstimateEnabled === true &&
        form.state.isTimeEstimateEnabled === false && (
          <DiscoAlert
            severity={"warning"}
            message={
              <DiscoText
                variant={"body-sm"}
                testid={"ContentModuleTimeEstimateSetting.warning"}
              >
                {`Turning this off will remove time estimates for all content in this module.`}
              </DiscoText>
            }
            marginTop={1}
            marginBottom={1}
          />
        )}
    </>
  )
  function handleToggle(checked: boolean) {
    form.state.isTimeEstimateEnabled = checked
  }
}
export default observer(ContentModuleTimeEstimateSetting)
